import { FEATURES } from "../data";
import SectionHeader from "./SectionHeader";
import { useSectionTrack } from "../hooks/useSectionTrack";

export default function Features() {
  const ref = useSectionTrack("features");

  return (
    <section ref={ref} id="features" className="sec" style={{ background: "transparent" }}>
      <SectionHeader label="Возможности" title="Только то, что нужно. Без лишнего." maxWidth={520} />
      <div className="grid-4">
        {FEATURES.map((f, i) => (
          <div
            key={f.title}
            className={`glass card-base card-pad card-lift section-enter section-enter-delay-${i + 1}`}
          >
            <div className="icon-box">{f.icon}</div>
            <div className="card-title" style={{ marginBottom: 8 }}>{f.title}</div>
            <div className="card-body">{f.body}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
